
import style from './loading.module.css';

export const Loading = () => {
  return (
    <div className={style.ldsEllipsis}><div></div><div></div><div></div><div></div></div>
  )
}